import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AprRatesComponent } from './page/masterdata/apr-rates/apr-rates.component';
import { DummyRoutesComponent } from './page/masterdata/dummy-routes/dummy-routes.component';
import { RailPointsComponent } from './page/masterdata/rail-points/rail-points.component';
import { SwitchPointsComponent } from './page/masterdata/switch-points/switch-points.component';
import { AddAprRateComponent } from './core/dialogs/add-apr-rate/add-apr-rate.component';
import { MsalGuard } from './msal';
import { Unauthorized } from './page/unauthorized/unauthorized/unauthorized';

const routes: Routes = [
  {
    path: '', component: AprRatesComponent, pathMatch: 'full',
    data: { breadcrumb: 'APR Rates' },
    canActivate: [MsalGuard]
  },
  {
    path: 'aprrates', component: AprRatesComponent,
    data: { breadcrumb: 'APR Rates' },
    canActivate: [MsalGuard]
  },
  {
    path: 'dummyroutes', component: DummyRoutesComponent,
    data: { breadcrumb: 'Dummy Routes' },
    canActivate: [MsalGuard]
  },
  {
    path: 'railpoints', component: RailPointsComponent,
    data: { breadcrumb: 'Rail Points' },
    canActivate: [MsalGuard]
  },
  {
    path: 'switchpoints', component: SwitchPointsComponent,
    data: { breadcrumb: 'Switch Points' },
    canActivate: [MsalGuard]
  },
  {
    path: 'unauthorized', component: Unauthorized,
    data: { breadcrumb: '' }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }